// ============================================================================
// B+ TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'b-plus-tree',
  name: 'B+ Tree',
  category: 'Data Structures',
  complexity: {
    time: 'O(log N) per operation',
    space: 'O(N)'
  },
  description: 'A balanced tree data structure optimized for disk storage and database systems. All data records are stored in leaf nodes, and internal nodes only store keys for navigation, enabling efficient range queries and sequential access.'
};
